// extracted by mini-css-extract-plugin
module.exports = {"text":"PermissionsModal_text__3zYW2","permissions":"PermissionsModal_permissions__1RDhS","button":"PermissionsModal_button__1IgOf"};